import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { MessageTail } from '@r1-frontend/ui-react/components/svg/chat';
import { LampCharge } from '@r1-frontend/ui-react/components/svg/notifications';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph2 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { ListContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import * as ST from './styled';

interface IProps {
    title?: string,
    text?: string,
}

const DEFAULT_TITLE = 'Извините, это наша внутренняя ошибка 500';
const DEFAULT_TEXT = `Наши инженеры уже её${NBSP}исправляют. Попробуйте обновить страницу. А${NBSP}если это не${NBSP}помогло, напишите нам, пожалуйста`;
const IMAGE_URL = '/static/images/errorPages/500/maskot';

const Page500 = ({
    title = DEFAULT_TITLE,
    text = DEFAULT_TEXT,
}: IProps) => {
    const { asPath } = useRouter();

    return (
        <ST.Wrapper $size={0} $justifyContent='center' $alignItems='center'>
            <ListContainer $size={20} $justifyContent='center' $wrap='nowrap'>
                <ST.ImageWrapper>
                    <WebpImage urlWebp={`${IMAGE_URL}.webp`}>
                        <img src={`${IMAGE_URL}.png`} alt='Изображение помощника' />
                    </WebpImage>
                </ST.ImageWrapper>
                <ListContainer $desktop={32} $mobile={24} $direction='column'>
                    <NonStaticContainer $united={{ $position: 'relative' }}>
                        <ST.MessageBody indent={{ $desktop: [32], $mobile: [24] }} rounder={{ $radius: 24 }} bgColor={COLORS.BgMain}>
                            <TextWrapper $lastIndent={false}>
                                <H2>{title}</H2>
                                <Paragraph2>{text}</Paragraph2>
                            </TextWrapper>
                            <ST.MessageTailContainer $desktop={{ $bottom: 0, $left: -18 }} $mobile={{ $bottom: 0, $left: -6 }}>
                                <MessageTail color={COLORS.BgMain} />
                            </ST.MessageTailContainer>
                            <ST.MobileImageWrapper>
                                <WebpImage urlWebp={`${IMAGE_URL}-mobile.webp`}>
                                    <img src={`${IMAGE_URL}-mobile.png`} alt='Изображение помощника' />
                                </WebpImage>
                            </ST.MobileImageWrapper>
                        </ST.MessageBody>
                    </NonStaticContainer>
                    <ST.SIndentContainer $desktop={[0, 32, 32]} $mobile={[0]}>
                        <ButtonGroup>
                            <a href='/' data-test='redirect-link'>
                                <Button bType='accent'>
                                    {asPath === '/' ? 'Обновить страницу' : 'На главную'}
                                </Button>
                            </a>
                            <a href='/chat' target='_blank'>
                                <Button bType='secondary' Icon={<LampCharge />}>
                                    Сообщить об ошибке
                                </Button>
                            </a>
                        </ButtonGroup>
                    </ST.SIndentContainer>
                </ListContainer>
            </ListContainer>
        </ST.Wrapper >
    );
};

export default Page500;
